import { FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styles from "./assignment.module.scss";
import clsx from "clsx";
import { InputAdornment, OutlinedInput, TextField } from "@mui/material";
import { Icon } from "../Component";
import DateTimePicker from "../../pages/components/forms/DateTimePicker";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";

const ExampleCustomInput = forwardRef(({ value, onClick, onChange, error }, ref) => (
  <div onClick={onClick} ref={ref}>
    <div className="form-icon form-icon-left">
      <Icon name="calendar"></Icon>
    </div>
    <input
      className={`form-control date-picker ${error ? "error" : ""}`}
      type="text"
      value={value}
      onChange={onChange}
    />
  </div>
));

const SoldModal = (props) => {
  const { handleSubmit, price, setPrice, priceError, setPriceError, date, setDate, dateError, setDateError, data } =
    props;

  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered className={styles.soldModal}>
      <ModalHeader closeButton>Change Status</ModalHeader>
      <ModalBody>
        <div className={styles.modalForm}>
          <div>
            <FormGroup>
              <Label style={{ marginBottom: "0" }}>Sold Price*</Label>
              <div className="form-control-wrap">
                <div className="form-icon form-icon-left">
                  <Icon name="sign-usd"></Icon>
                </div>
                <input
                  type="text"
                  className={clsx("form-control", styles.textField, priceError ? "error" : "")}
                  value={price}
                  name="price"
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) {
                      setPrice(e.target.value);
                      setPriceError(false);
                    }
                  }}
                />
              </div>
            </FormGroup>
          </div>

          <div>
            <FormGroup>
              <Label style={{ marginBottom: "0" }}>Sold Date*</Label>
              <div className="form-control-wrap">
                <div className="form-icon form-icon-left">
                  <Icon name="calendar" />
                </div>
                <DatePicker
                  selected={date}
                  className="form-control date-picker"
                  isClearable
                  onChange={(date) => {
                    setDate(date);
                    setDateError(false);
                  }}
                  customInput={<ExampleCustomInput error={dateError} />}
                />
              </div>
            </FormGroup>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <div>
          <button
            onClick={() => {
              // if (!price || !date) {
              //   if (!price) setPriceError(true);
              //   if (!date) setDateError(true);
              //   return;
              // }
              handleSubmit(data);
            }}
          >
            Change Status
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default SoldModal;
